import { computed, ComputedRef, Ref } from 'vue';
import { RatingHelper } from '@/shared/helper/RatingHelper';
import { RatingSummary, RatingSummaryOverlay } from '@shared/types/RatingSummary';

export const useRating = (rating: Ref<RatingSummary> | ComputedRef<RatingSummary | RatingSummaryOverlay>) => {
  const showRatingBadge = computed(() => {
    return RatingHelper().showRatingBadge(rating.value.ratingCount, rating.value.ratingAverage);
  });

  return {
    showRatingBadge,
  };
};
